// DownloadApp.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const DownloadApp = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.iberostar.com/es/app-iberostar/",
    en: "https://www.iberostar.com/en/app-iberostar/",
    de: "https://www.iberostar.com/de/app-iberostar/",
    fr: "https://www.iberostar.com/fr/app-iberostar/",
    it: "https://www.iberostar.com/it/app-iberostar/",
    pt: "https://www.iberostar.com/pt/app-iberostar/",
    ru: "https://www.iberostar.com/ru/app-iberostar/",
  };
  return (
    <>
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="bi bi-app icon-space" />
        App
      </button>
      {showModal && (
        <LanguageModal
          title="App"
          icon="bi bi-app"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default DownloadApp;
